module.exports = __webpack_public_path__ + "static/media/Brands_28.9fa50054.png";